const hasNavigator = typeof navigator !== 'undefined'

const isWindowsPhone = hasNavigator && /windows phone/i.test(navigator.userAgent)

const isAndroid = hasNavigator && !isWindowsPhone && /android/i.test(navigator.userAgent)

const isIPadPro = hasNavigator && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1

export const isIOS =
  hasNavigator &&
  !isWindowsPhone &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) || isIPadPro) &&
  !window.MSStream

export const isMobileDevice = hasNavigator && (isWindowsPhone || isAndroid || isIOS)

export const isSafari = navigator?.vendor.indexOf('Apple') > -1

export const mustUseHLS = isIOS || isSafari
